import React from "react";

import { FormControlLabel, Stack, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";

import { PaymentTerm } from "./form-fields/PaymentTerm";
import { FormValues } from "./schemas";

interface Props {
  formik: FormikProps<FormValues>;
  hasWithdrawals?: boolean;
}

export const FacilityTermsPaymentSection: React.FC<Props> = ({ formik, hasWithdrawals = false }) => {
  const { t } = useTranslation("debt");
  const isWithdrawal = formik.values.is_withdrawal;
  const isFacility = formik.values.is_facility;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <PaymentTerm
        formik={formik}
        disabled={!isFacility && !formik.values.overriding_parent}
        showCustomIndexationOptions={false}
      />
      {isFacility && !hasWithdrawals && (
        <FormControlLabel
          control={
            <Switch
              checked={isWithdrawal}
              onChange={(e) => {
                formik.setFieldValue("is_withdrawal", e.target.checked);
                if (!e.target.checked) {
                  formik.setFieldValue("principal_first_payment_date", null);
                  formik.setFieldValue("balloon_payment", null);
                  formik.setFieldValue("interest_first_payment_date", null);
                }
              }}
              name="is_withdrawal"
            />
          }
          slotProps={{
            typography: {
              sx: { whiteSpace: "nowrap" }
            }
          }}
          label={t("paymentSection.singlePayment")}
          labelPlacement="start"
        />
      )}
      {isWithdrawal && !isFacility && (
        <FormControlLabel
          control={
            <Switch
              checked={formik.values.overriding_parent}
              onChange={(e) => {
                formik.setFieldValue("overriding_parent", e.target.checked);
              }}
              name="overriding_parent"
            />
          }
          slotProps={{
            typography: {
              sx: { whiteSpace: "nowrap" }
            }
          }}
          label={t("paymentSection.overrideFacilityTerms")}
          labelPlacement="start"
        />
      )}
    </Stack>
  );
};
